import { Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import StickyConsultCta from "@/components/StickyConsultCta";
import ApiHealthBanner from "@/components/ApiHealthBanner";

export default function Layout() {
    return (
        <div className="min-h-screen flex flex-col bg-background text-foreground">
            <ApiHealthBanner />
            <Navbar />
            <main className="flex-1">
                <Outlet />
            </main>
            <Footer />
            <StickyConsultCta />
        </div>
    );
}
